export default __webpack_public_path__ + "static/media/48.49468108.jpg";